import React from 'react';
// import { withCookies } from 'react-cookie';
import { connect } from 'react-redux';
import * as faqAction from './../../action/faqAction';
// import FaqData from './faqData';
import Modal from 'react-responsive-modal';
import { updatePageLogs, checktime, catchJSException } from './../../service/logService';
import { updateSCTags } from './../../service/dtmTag';
import { getVZDLInit } from './../../service/vzdl';
import ReactHtmlParser, { convertNodeToElement } from 'react-html-parser';
import { Utils } from '../../util/utils';

export class Faq extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      openFlag: false,
      expanded: false,
      close: 0,
      pageName: '',
    };
  }
  openModelBox = (evt) => {
    try {
      updateSCTags('faqs');
      let txnData = {
        total: this.props.cartProduct.total,
        taxAmt: this.props.cartProduct.tax,
        shippingZip: '',
        shippingCharge: this.props.cartProduct.shippingcrg,
        paymentType: '',
        status: '',
      };
      getVZDLInit(this.props.appState.visitId, this.state.pageName, '', '', 'faq', '', 'Accessories', '', '', {
        cartData: this.props.cartProduct.cartProduct,
        txnData: txnData,
      });
      this.setState({
        openFlag: true,
      });
      let rootElement = document.getElementById('root');
      rootElement ? rootElement.setAttribute('aria-hidden', true) : '';
      let chatElement = document.getElementsByClassName('LPMcontainer');
      if (chatElement && chatElement.length > 0) {
        chatElement[0] ? chatElement[0].setAttribute('aria-hidden', true) : '';
        chatElement[1] ? chatElement[1].setAttribute('aria-hidden', true) : '';
      }
    } catch (ex) {
      catchJSException('faq_index', this.props.appState.visitId, 'openModelBox', ex);
    }
  };

  onCloseModal = () => {
    try {
      updateSCTags('close faqs');
      this.setState({ openFlag: false });
      let rootElement = document.getElementById('root');
      rootElement ? rootElement.setAttribute('aria-hidden', false) : '';
      let chatElement = document.getElementsByClassName('LPMcontainer');
      if (chatElement && chatElement.length > 0) {
        chatElement[0] ? chatElement[0].setAttribute('aria-hidden', false) : '';
        chatElement[1] ? chatElement[1].setAttribute('aria-hidden', false) : '';
      }
    } catch (ex) {
      catchJSException('faq_index', this.props.appState.visitId, 'onCloseModal', ex);
    }
  };
  componentWillMount() {
    // faqAction.getFaqFromJSON(this.props.dispatch)
    var faqData = window.faqresp;
    if (faqData !== undefined && faqData !== '' && faqData !== null) {
      this.props.dispatch({ type: 'FAQFROMAPI', value: faqData.description });
      window.faqresp;
    } else {
      faqAction.getFaqFromApi(this.props.appState.visitId, this.props.dispatch);
    }
    checktime(this.callCheckTime('WillMount'));
    this.processPageAfterVisitID();

    let pageName = '';
    let categoryList = this.props.categoriesState && this.props.categoriesState.categoriesExp;
    let productList = this.props.productstate && this.props.productstate.productsExp;
    let urlName = this.props.props ? this.props.props.match.params.pageName : this.props.match.params.pageName;
    if (pageName === '' && Utils.isNotNull(productList)) {
      pageName = productList.find((obj) => obj.modifiedName === urlName);
    }
    if (window.location.pathname === '/home/accessories/shoppingcart/') {
      pageName = 'ShoppingCart';
    }
    if (urlName !== undefined && urlName !== '') {
      pageName = pageName ? pageName.name : urlName.replace(/[-]/g, ' ');
    }
    this.setState({
      pageName: pageName,
    });
  }
  processPageAfterVisitID = () => {
    try {
      updatePageLogs(this.props.appState, this.props.appState.visitId, false);
      checktime(this.callCheckTime('Mount'));
      // getDTMInit("checkAvaillqInit", { appInfo: this.props.appState, lqInfo: this.props.lqState });
    } catch (ex) {
      catchJSException('visitId_Error', this.props.appState.visitId, 'processPageAfterVisitID', ex);
    }
  };
  callCheckTime = (pagestate) => {
    return {
      page: 'FAQ',
      mount: pagestate === 'Mount' && Date.now(),
      unmount: pagestate === 'WillMount' && Date.now(),
      pageURL: window.location.href,
      visitid: this.props.appState.visitId || 'visit_id_not_created',
      noSSNCheck: false,
      apiFetched: pagestate === 'ApiFetched' && Date.now(),
    };
  };

  onFaqEnter = (e) => {
    if (e.charCode === 13 || e.keyCode === 13) {
      this.openModelBox(e);
    }
  };

  showAns = (Index) => {
    try {
      let id = document.getElementById(Index);
      if (id.className === 'm_accordion-summary m_single') {
        let content = id.textContent && id.textContent.trim().split(' ').splice(-3).join(' ');
        updateSCTags('faq: ' + content);
        id.className = 'm_accordion-summary m_single open';
        id.ariaExpanded = 'true';
        id.nextElementSibling.style = 'display:block';
        if (this.state.close !== 0) {
          document.getElementById(this.state.close).className = 'm_accordion-summary m_single';
          document.getElementById(this.state.close).ariaExpanded = 'false';
          document.getElementById(this.state.close).nextElementSibling.style = 'display:none';
        }
        this.setState({
          close: Index,
        });
      } else if (id.className === 'm_accordion-summary m_single open') {
        id.className = 'm_accordion-summary m_single';
        id.ariaExpanded = 'false';
        id.nextElementSibling.style = 'display:none';
        this.setState({
          close: 0,
        });
      }
    } catch (ex) {
      catchJSException('faq', '', 'showAns', ex);
    }
  };
  htmlParserTransform = (node, index) => {
    if (node.type === 'tag' && node.name === 'a') {
      node.attribs.style = 'display:none';
      return convertNodeToElement(node, index, this.htmlParserTransform);
    } else if (node.type === 'tag' && node.name === 'li' && node.attribs.class === 'm_accordion-summary m_single') {
      // a tag named a
      node.attribs.class = ' ';
      return (
        <li
          id={'id' + index}
          class="m_accordion-summary m_single"
          onClick={() => this.showAns('id' + index)}
          tabIndex="0"
          role="button"
          onKeyPress={() => this.showAns('id' + index)}
          aria-expanded="false"
        >
          <span pointerEvents="none">{convertNodeToElement(node, index, this.htmlParserTransform)}</span>
        </li>
      );
    } else if (node.type === 'tag' && node.name === 'li' && node.attribs.class === 'm_accordion-details m_single') {
      node.attribs.style = 'display:none';
    } else if (node.type === 'tag' && node.name === 'button') {
      return (
        <button
          onClick={() => this.onCloseModal()}
          className="button center medium-p-auto  margin-bottom-medium no-focus-effect"
          data-close-modal=""
          tabIndex="0"
        >
          Close
        </button>
      );
    } else if (node.type === 'tag' && node.name === 'h4') {
      return <h2>Q &amp; A</h2>;
    }
    // else if (node.type === "tag" && node.name === "div" && node.attribs.class === "w_modal m_medium m_modal-width") {
    //     node.attribs.style = "max-height: 268.2px;top: 51%;margin-top: -34px;"
    //     return convertNodeToElement(node, index, this.htmlParserTransform);
    // }
  };

  render() {
    const { openFlag } = this.state;
    // let faqData = <FaqData appState={this.props.appState} />
    let content;
    if (this.props.faqState.faqExp) {
      content = this.props.faqState.faqExp;
      content = content.replace(/class="w_modal m_medium m_modal-width" data-modal="FAQmodal"/g, ' data-modal="FAQmodal"');
    }
    return (
      <div className="faq">
        <div data-open-modal="FAQmodal">
          <span onClick={this.openModelBox} className="vzicon middle icon-question-answer"></span>
          <span
            onClick={this.openModelBox}
            tabIndex="0"
            role="button"
            aria-label="Frequently asked questions"
            onKeyPress={(e) => this.onFaqEnter(e)}
            className="faq-text bold padding-left-micro"
          >
            Frequently asked questions
          </span>
          <Modal
            open={openFlag}
            center
            focusTrapped={true}
            showCloseIcon={false}
            onOverlayClick={() => this.onCloseModal()}
            onEscKeyDown={() => this.onCloseModal()}
          >
            <a
              onClick={() => this.onCloseModal()}
              onKeyPress={() => this.onCloseModal()}
              class="vzicon close-faq"
              tabIndex="0"
              aria-label="Close"
              role="button"
            >
              &times;
            </a>
            {ReactHtmlParser(content, { transform: this.htmlParserTransform })}
          </Modal>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    faqState: state.faqDetailsVTP,
    appState: state.appVTP,
    categoriesState: state.categoriesVTP,
    productstate: state.productsVTP,
    cartProduct: state.cartProductDataVTP,
  };
};
export default connect(mapStateToProps)(Faq);
